export default __webpack_public_path__ + "static/lefafa_2_1-8e0eac9e5b31e9b77283ed96ced92e5c.webp";